import { Bounce, type ToastOptions, toast } from "react-toastify"

interface EmitToast {
  type: "info" | "success" | "error" | "warn"
  message: string
  customOptions?: ToastOptions
}

export const defaultToastConfig: ToastOptions = {
  position: "top-center",
  autoClose: 2500,
  hideProgressBar: true,
  closeOnClick: false,
  pauseOnHover: false,
  draggable: false,
  progress: undefined,
  theme: "light",
  transition: Bounce,
  bodyStyle: {
    fontSize: 14,
    lineHeight: 1.4,
  },
}

export function emitToast({ type, message, customOptions }: EmitToast) {
  return toast[type](message, { ...defaultToastConfig, ...customOptions })
}
